import Bar, {BarButton, RefreshButton} from "../uiUtils/Bar";
import {Carousel, Dropdown, Layout, Modal, notification, Popconfirm} from "antd";
import {SpecAdResults} from "./SpecAdResults";
import React, {useContext, useEffect, useState} from "react";
import { partial} from "lodash";
import {EditableInfo} from "../uiUtils/EditableInfo";
import {AppController} from "../App";
import * as PropTypes from "prop-types";
import {DeleteOutlined, ExportOutlined, FileAddOutlined, FolderViewOutlined} from "@ant-design/icons";
import {getShareMenu} from "../uiUtils/Helpers";
import ReactBnbGallery from "react-bnb-gallery";
import 'react-bnb-gallery/dist/style.css';

export function SalesSheetView(
    {
        salesSheet, setSalesSheet, advertiser,
        onAppend, onDelete,
        goToWizard, shareSalesSheet,
        refresh, mode,
        ...props
    })
{
    const shareMenu=getShareMenu({item:salesSheet, onAction:shareSalesSheet});
    //const [visible, setVisible] = useState(false);
    const [activePhotoIndex, setActivePhotoIndex] = useState();

    useEffect(()=>{
        if (mode==='present') {
            setActivePhotoIndex(0)
        }
    },[mode])
    const onPresent = ()=>setActivePhotoIndex(0)

    return <div {...props}>
        <Bar>
            <span style={{fontWeight:'bold',fontSize:'larger'}}>Presentation: </span>
            <RefreshButton onRefresh={refresh} primary={false} title={'refresh presentation'}/>
            <BarButton icon={<FileAddOutlined/>} onClick={onAppend}>New Ad</BarButton>
            <Dropdown overlay={shareMenu}>
                <BarButton icon={<ExportOutlined/>} placement={"left"}
                           title={"Print, email or view a PDF of Presentation ads"}
                >Share...</BarButton>
            </Dropdown>
            <BarButton icon={<FolderViewOutlined/>} title={"Present mode"}
                       onClick={onPresent} disabled={!salesSheet||salesSheet.specAds.length===0}>
                Present
            </BarButton>
            <Popconfirm title={'Comfirm delete'}
                        okText={'Delete'}
                        onConfirm={onDelete}>
                <BarButton icon={<DeleteOutlined/>} >Delete</BarButton>
            </Popconfirm>
        </Bar>
        <Layout>
            <Layout.Sider theme={"light"} width={300} style={{padding:5}}>
                <SalesSheetInfo
                    salesSheet={salesSheet}
                    setSalesSheet={setSalesSheet}
                    onChange={(obj)=>notification.info({
                        title: 'Update SS',
                        description: JSON.stringify(obj)
                    })}
                />
            </Layout.Sider>
            <Layout.Content>
                <SpecAdResults {...{salesSheet, advertiser, goToWizard}}
                    openGallery={setActivePhotoIndex}/>
            </Layout.Content>
        </Layout>
        <Gallery assets={salesSheet? salesSheet.specAds : []}
                 activePhotoIndex={activePhotoIndex}
                 setActivePhotoIndex={setActivePhotoIndex}
        />
    </div>;
}
SalesSheetView.propTypes = {
    onAppend: PropTypes.func,
    onDelete: PropTypes.func,
    salesSheet: PropTypes.any,
    advertiser: PropTypes.any
};

const Gallery = ({assets=[], activePhotoIndex, setActivePhotoIndex,  ...props}) => {

    const [photos, setPhotos] = useState([]);

    useEffect(()=>{
        setPhotos(assets.map((a,i)=>({
                photo: a.previewUrl,
                thumbnail: a.thumbUrl,
                caption: a.jobNumber || a.metroReference,
                subcaption: a.notes,
                number: i+1
            })));
    },[assets])

    return <ReactBnbGallery
                activePhotoIndex={activePhotoIndex}
                showThumbnails={false}
                show={activePhotoIndex>=0}
                photos={photos}
                onClose={() => setActivePhotoIndex()}
            />
};


/*
// jsx issue with this lib  don't have time to get to the bottom of
// shame as it has a nice full screen mode
function Gallery({assets, visible, setVisible, ...props}){

    const gallery = useRef(null);

    useEffect(()=>{
        if (visible) {
            gallery.fullScreen();
        }
    }, [visible]);

    const images = assets.map(a=>(
        {
            original: a.previewUrl,
            thumbnail: a.thumbUrl,
            description: a.jobNumber || a.metroReference
        })
    );

    return <div style={{display: 'none'}}>
        <ImageGallery items={images} useBrowserFullscreen={false} lazyLoad={true}
                      onScreenChange={full=>setVisible(full)}
                      ref={gallery}
        />
    </div>;
}
 */

function ModalGallery({visible, salesSheet, setVisible, ...props}){
    return <Modal visible={visible}
                  style={{
                      width: '100vw',
                      height: '100vh'
                  }}
                  footer=''
                  onCancel={()=>setVisible(false)}
    >
        {salesSheet &&
        <Carousel>
            {salesSheet.specAds.map(sa=><div key={sa.id}>
                <img alt={sa.jobNumber||sa.metroReference} src={sa.previewUrl}
                     style={{maxWidth:'100%', maxHeight:'100%'}}/>
            </div>)}
        </Carousel>
        }
    </Modal>
}

function SalesSheetInfo({salesSheet, setSalesSheet}) {

    const {
        name, jobNumber,
        createdDate, updatedDate,
        salesRep, createdBy,
        advertiserName,
        specAds,
        notes
    } = salesSheet;

    const controller = useContext(AppController);

    async function update(field,value){

        // todo
        //  "computed properties" not being transpiled - not sure why
        //  MS Electron barfs on them
        //  ?Can alter my code but what about modules?
        //controller.updateSalesSheet(salesSheet, {[field]: value});

        const changes = {}
        changes[field] = value
        //todo really ought to be in model...
        const newSalesSheet = await controller.updateSalesSheet(salesSheet, changes)
        setSalesSheet(newSalesSheet)
    }

    const data = [
        {label:'Name', value:name , onChange:partial(update,'name')},
        {label:'Job Ref', value: jobNumber, onChange:partial(update,'jobNumber')},
        {label:'Advertiser', value:advertiserName},
        {label:'Sales Rep', value: `${salesRep.firstName} ${salesRep.lastName}`},
        {label:'Last update', value: updatedDate.toDateString()},
        {label:'# of Ads', value: specAds.length},
        {label:'Created by', value: `${createdBy.firstName} ${createdBy.lastName}`},
        {label:'Created on', value: createdDate.toDateString()},
        {label:'Notes', value: notes, onChange: partial(update,'notes'), stack:true}
    ];

    // todo ?Use Icons, Links for Adv & Rep
    return <EditableInfo data={data}/>
}

